import * as React from 'react';

const Us16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#F1F2F1",
    d: "M1 5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V5Z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#CB001C",
    d: "M2.991 13a1.997 1.997 0 0 1-1.568-.77h13.154a1.997 1.997 0 0 1-1.568.77H2.99ZM1 10.69V11c0 .158.018.312.053.46h13.894c.035-.148.053-.302.053-.46v-.31H1Zm0-1.54h14v.77H1v-.77Zm0-1.53h14v.77H1v-.77Zm0-1.54h14v.77H1v-.77Zm.053-1.54A2.006 2.006 0 0 0 1 5v.31h14V5c0-.158-.018-.312-.053-.46H1.053ZM13 3H3c-.64 0-1.211.301-1.577.77h13.154A1.997 1.997 0 0 0 13 3Z"
  }
), /* @__PURE__ */ React.createElement("path", { fill: "#2A3560", d: "M1 5a2 2 0 0 1 2-2h4.39v5.39H1V5Z" }));
Us16.Size = 16;
Us16.Title = "Us";

export { Us16 as default };
